import { render } from "./Example5.vue?vue&type=template&id=30c2e832&scoped=true&ts=true"
import script from "./Example5.vue?vue&type=script&lang=ts"
export * from "./Example5.vue?vue&type=script&lang=ts"

import "./Example5.vue?vue&type=style&index=0&id=30c2e832&scoped=true&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c2e832"]])

export default __exports__